import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Resources from '../resourceLinks/ResourceLinks';
import Image from '../../objects/image/SecondaryImage';
import AudioControls from "../audio/SimpleAudioController";
import * as appConstants from "../../../constants/appConstants";
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as componentConstants from '../../../constants/componentConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as imageHelper from '../../../helpers/imageHelper';
import * as animationHelper from "../../../helpers/animationHelper";

class QuestionPrompt extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            screenObject: props.screenObject,
            lang: this.props.lang,
            locale: appHelper.getLocalData(this.props.screenObject),
            isVisible: false,
            icon: {
                src: "",
            },
            screenAsset: {
                src: ""
            },
            hasLeftAsset: appHelper.isDefined(props.screenObject.prompt_settings.left),
            hasRightAsset: appHelper.isDefined(props.screenObject.prompt_settings.right),
            hasTopAsset: appHelper.isDefined(props.screenObject.prompt_settings.top),
            hasBottomAsset: appHelper.isDefined(props.screenObject.prompt_settings.bottom),
            assetData: {},
            resourceLinks: [],
            hasResources: false,
            imageStyles: {},
            imageClass: "",
            updateImageStyles: false,
            imageStylesSet: false,
            refValue: `${this.props.screenObject.asset_id}_promptWrapper`,
            audio: {
                src: "",
            },
            allowAudioAutoPlay: appHelper.isDefined(props.allowAudioAutoPlay) ? props.allowAudioAutoPlay : true,
            showLabels: true,
            showAnimation: false,
        };

        this.show = this.show.bind(this);
        this.onShowComplete = this.onShowComplete.bind(this);
        this.hide = this.hide.bind(this);
        this.onHideComplete = this.onHideComplete.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getAssetType = this.getAssetType.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.setClass = this.setClass.bind(this);
        this.setIconClass = this.setIconClass.bind(this);
        this.setResources = this.setResources.bind(this);
        this.getImageStyles = this.getImageStyles.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);

        //Create Refs
        this.prompt = React.createRef();
        this.promptAsset = React.createRef();
    }

    componentDidMount() {
        this.setResources();

        this.getAssets();
        this.getImageStyles();
        if((appHelper.isDefined(this.props.animatePrompt) && this.props.animatePrompt) || !appHelper.isDefined(this.props.animatePrompt)) {
            this.show();
        }
        //this.show();
        //this.props.onComplete();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: Object.assign({}, nextProps.lang),
                locale: appHelper.getLocalData(this.state.screenObject),
            });
        }
    }

    componentDidUpdate() {
        if (!this.state.imageStylesSet) {
            this.getImageStyles();
        }
    }


    show() {
        let prompt = this.prompt.current;
        let params = {
            ele: prompt,
            duration: objectConstants.SHOW_PANEL_DURATION,
            delay: 0,
            callback: this.onShowComplete
        };
        animationHelper.showHeight(params);
    }


    onShowComplete() {
        this.setState({isVisible: true});
        if (appHelper.isDefined(this.props.onComplete)) {
            this.props.onComplete();
        }
    }

    hide() {
        let prompt = this.speachBubble.current;
        let params = {
            ele: prompt,
            duration: objectConstants.SPEECH_BUBBLE_DURATION,
            delay: 0,
            callback: this.onHideComplete
        };
        animationHelper.hideHeight(params);
    }

    onHideComplete() {
        this.setState({isVisible: false});
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setResources() {
        let resourceLinks = appHelper.setResourceLinks(this.state.screenObject.prompt_settings);
        let hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);

        this.setState({
            resourceLinks: Object.assign([], resourceLinks),
            hasResources: resourceLinks.length > 0,
            resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
        });

    }

    onResourcesComplete() {

    }


    getAssets() {
        let screenAsset = {};
        let assetData = {};


        if (this.state.hasLeftAsset) {
            screenAsset = this.getAssetType(this.state.screenObject.prompt_settings.left);
            assetData = Object.assign({}, this.state.screenObject.prompt_settings.left);
        } else if (this.state.hasRightAsset) {
            screenAsset = this.getAssetType(this.state.screenObject.prompt_settings.right);
            assetData = Object.assign({}, this.state.screenObject.prompt_settings.right);
        } else if (this.state.hasTopAsset) {
            screenAsset = this.getAssetType(this.state.screenObject.prompt_settings.top);
            assetData = Object.assign({}, this.state.screenObject.prompt_settings.top);
        } else if (this.state.hasBottomAsset) {
            screenAsset = this.getAssetType(this.state.screenObject.prompt_settings.bottom);
            assetData = Object.assign({}, this.state.screenObject.prompt_settings.bottom);
        }

        if (assetData.constant === assetConstants.ASSET_TYPE_IMAGE) {
            assetData = Object.assign({}, assetData, {
                allow_diagram_zoom: this.state.screenObject.prompt_settings.allow_diagram_zoom,
                show_diagram_title: this.state.screenObject.prompt_settings.show_diagram_title,
                show_diagram_description: this.state.screenObject.prompt_settings.show_diagram_description,
            });
        }

        if (appHelper.isDefined(this.state.screenObject.audio) && appHelper.isDefined(this.state.locale.audio)) {
            let audio = appHelper.getAudioAsset(this.state.locale.audio);
            if (appHelper.isDefined(this.state.screenObject.audio.enabled) && this.state.screenObject.audio.enabled) {
                if (this.state.screenObject.asset_type_code === componentConstants.AUDIO_CHOICE || (appHelper.isDefined(this.state.screenObject.audio.show_audio_controls) && this.state.screenObject.audio.show_audio_controls)) {
                    this.setState({
                        audio: Object.assign({}, audio),
                    });
                } else {
                    let audioObj = {
                        audioRef: `audio_${audio.id}_${audio.type}`,
                    };
                    if (this.state.allowAudioAutoPlay && appHelper.isDefined(this.state.screenObject.audio.auto_play) && this.state.screenObject.audio.auto_play) {
                        this.props.actions.setAudio(audioObj);
                    }
                }
            }

        }

        this.setState({
            screenAsset: Object.assign({}, screenAsset),
            assetData: Object.assign({}, assetData)
        });

    }

    getAssetType(asset) {

        let returnAsset = {};
        if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
            returnAsset = appHelper.getIconAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
            returnAsset = appHelper.getImageAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
            returnAsset = appHelper.getLibraryImageAsset(asset);
        }
        returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;

        if (appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)) {
            returnAsset = Object.assign({}, returnAsset, {
                type: asset.constant
            });
        }

        return returnAsset;
    }

    setClass() {

        let className = "";
        if (appHelper.isDefined(this.state.screenObject.prompt_settings.class_name) && this.state.screenObject.prompt_settings.class_name.length > 0) {
            className += ` ${this.state.screenObject.prompt_settings.class_name}`;
        } else {
            className += "standard-block";
        }

        if (appHelper.isDefined(this.state.screenObject.prompt_settings.bullet_list_style) && this.state.screenObject.prompt_settings.bullet_list_style !== null) {
            className += ` ${this.state.screenObject.prompt_settings.bullet_list_style}`;
        }
        return className;
    }

    setIconClass() {
        let iconClass = '';

        if (this.state.hasLeftAsset) {

            iconClass += 'left-asset ';
        } else if (this.state.hasRightAsset) {
            iconClass += 'right-asset ';
        } else if (this.state.hasTopAsset) {
            iconClass += 'top-asset ';
        } else if (this.state.hasBottomAsset) {
            iconClass += 'bottom-asset ';
        }

        /*if (this.state.screenAsset.type === assetConstants.ASSET_TYPE_ICON) {
            iconClass += 'icon ';
        } else {
            iconClass += 'image ';
        }*/

        if (this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE) {
            iconClass += 'image ';
        }
        return iconClass;
    }

    getImageStyles() {
        let refValue = this.promptAsset.current;
        if (appHelper.isEleDefined(refValue) && appHelper.isDefined(this.state.screenAsset.src) && this.state.screenAsset.src.length > 0) {
            let assetStyles = imageHelper.checkAssetImageWidth(this.state.screenObject.prompt_settings, this.state.screenAsset, refValue.offsetWidth).styles;
            this.setState({
                updateImageStyles: false,
                imageStylesSet: true,
                imageStyles: Object.assign({}, assetStyles),
                imageClass: imageHelper.getAssetImageClass(this.state.screenObject.prompt_settings),
            });
        }
    }

    /*<div className={`object-container`} style={{marginBottom: `20px`}}>*/
    render() {
        return (
            this.state.locale.description.length > 0 ?
                <div className={(appHelper.isDefined(this.props.animatePrompt) && this.props.animatePrompt) || !appHelper.isDefined(this.props.animatePrompt) ? "a-c" : ""} ref={this.prompt}>
                    <div className={`object-container`} style={{marginBottom: `10px`}}>
                        <div className="object-wrapper">
                            <div className={`${this.setClass()}`}>
                                <div
                                    className={`paragraph-content-wrapper ${this.setIconClass()} ${this.state.screenObject.prompt_settings.image_size}-${this.state.screenObject.prompt_settings.asset_image_width}`}
                                    ref={this.promptAsset}>
                                    {this.state.hasLeftAsset || this.state.hasTopAsset
                                        ?
                                        <div className="asset-column">
                                            {this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                            &&
                                            <Image screenObject={this.state.assetData}
                                                   imageClass={this.state.imageClass}
                                                   imageStyles={this.state.imageStyles}/>

                                            }
                                            {this.state.assetData.constant !== assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                            &&
                                            <div className={`asset-image-wrapper ${this.state.imageClass}`}
                                                 style={this.state.imageStyles}>
                                                <img src={this.getImagePath(this.state.screenAsset.src)} alt=""/>
                                            </div>
                                            }

                                            {appHelper.isDefined(this.state.screenAsset.credit) && this.state.screenAsset.credit.length > 0 &&
                                            <div className={`image-credit`}
                                                 style={this.state.imageStyles}>{this.state.creditLabel}: {this.state.screenAsset.credit}</div>
                                            }

                                        </div>
                                        :
                                        null
                                    }
                                    <div className="content-column">
                                        {
                                            this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0
                                                ? <h4 className={this.state.screenObject.prompt_settings.title_style}
                                                      dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                                                : null
                                        }

                                        {appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                            ?
                                            <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                            : null
                                        }
                                        {
                                            appHelper.isDefined(this.state.screenObject.audio) && (this.state.screenObject.asset_type_code === componentConstants.AUDIO_CHOICE || (appHelper.isDefined(this.state.screenObject.audio.show_audio_controls) && this.state.screenObject.audio.show_audio_controls)) && appHelper.isDefined(this.state.audio.id)
                                                ?

                                                <AudioControls audio={this.state.audio}
                                                               autoPlay={this.state.screenObject.audio.auto_play && this.state.allowAudioAutoPlay}
                                                               showLabels={this.state.showLabels}
                                                               showAnimation={this.state.showAnimation}
                                                               audioRef={`text_audio_${this.state.screenObject.asset_id}_${this.state.audio.id}_${this.state.audio.constant}`}/>

                                                :
                                                null
                                        }
                                        {
                                            this.state.hasResources
                                                ?

                                                <Resources resources={this.state.resourceLinks}
                                                           onResourcesComplete={this.onResourcesComplete}/>

                                                :
                                                null
                                        }

                                    </div>
                                    {this.state.hasRightAsset || this.state.hasBottomAsset
                                        ?
                                        <div className="asset-column">
                                            {this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                            &&
                                            <Image screenObject={this.state.assetData}
                                                   imageClass={this.state.imageClass}
                                                   imageStyles={this.state.imageStyles}/>
                                            }
                                            {this.state.assetData.constant !== assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                            &&
                                            <div className={`asset-image-wrapper ${this.state.imageClass}`}
                                                 style={this.state.imageStyles}>
                                                <img src={this.getImagePath(this.state.screenAsset.src)} alt=""/>


                                            </div>
                                            }
                                            {appHelper.isDefined(this.state.screenAsset.credit) && this.state.screenAsset.credit.length > 0 &&
                                            <div className={`image-credit`}
                                                 style={this.state.imageStyles}>{this.state.creditLabel}: {this.state.screenAsset.credit}</div>
                                            }
                                        </div>
                                        :
                                        null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : <div ref={this.prompt}/>

        );
    }
}

QuestionPrompt.propTypes = {
    screenObject: PropTypes.object.isRequired,
    onComplete: PropTypes.func,
    allowAudioAutoPlay: PropTypes.bool,
    animatePrompt: PropTypes.bool,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

QuestionPrompt.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang: lang,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionPrompt);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/QuestionPrompt.js
 **/